import * as fe from "@runn/filter-engine"
import { useMemo } from "react"

import {
  AllowedProjectFilterSet,
  FilterableProject,
} from "~/helpers/filter-engine"

import usePeoplePlannerFilters from "~/PeoplePlanner/usePeoplePlannerFilters"
import { useViews } from "~/Views/useViews"

/**
 * Get the filter set for people planner. We pass in the filtered project IDs
 * from the project planner so that placeholders in visible projects are shown,
 * even if they don't match the people filters in the selected view.
 */
const usePeoplePlannerFilterSet = (
  projectPlannerFilterSet: AllowedProjectFilterSet,
  projectPreparedList: FilterableProject[],
) => {
  const { selectedView } = useViews()

  const filteredProjectPlannerProjectIds = useMemo(
    () =>
      new Set<number>(
        fe.engines.local
          .filterProjectList(projectPreparedList, projectPlannerFilterSet)
          .map((project) => project.id),
      ),
    [projectPreparedList, projectPlannerFilterSet],
  )

  const filterSet = usePeoplePlannerFilters(
    selectedView?.peopleFilters,
    Array.from(filteredProjectPlannerProjectIds.values()),
  )

  return filterSet
}

export default usePeoplePlannerFilterSet
